/* SUNVOLT – inline-sök toggle.
   Kopplar sök-ikonen ([data-sv-search-toggle], i .header__icons) till inline-sökfältet
   ([data-sv-search], grid-area heading). Öppna = .header får klassen .sv-search-active
   (CSS expanderar fältet och skjuter ut nav/ikoner). Stäng: ikon igen, Esc, klick utanför,
   eller stäng-X. Dawns predictive-search.js sköter själva sökträffarna (orört). */
(function () {
  function bind(header) {
    var toggle = header.querySelector('[data-sv-search-toggle]');
    // Söket ligger nu i .sv-search-row UTANFÖR <header> (rad under headern) → sök i hela dokumentet.
    var search = document.querySelector('[data-sv-search]');
    if (!toggle || !search || toggle.dataset.svBound) return;
    toggle.dataset.svBound = '1';

    var input = search.querySelector('input[type="search"]');
    var isOpen = function () { return header.classList.contains('sv-search-active'); };
    var isClosing = function () { return header.classList.contains('sv-search-closing'); };
    var mqMobile = window.matchMedia('(max-width: 989px)');
    var closeTimer;

    function open() {
      clearTimeout(closeTimer);
      header.classList.remove('sv-search-closing');
      document.body.classList.remove('sv-search-closing');
      header.classList.add('sv-search-active');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sv-search-open', 'overflow-hidden'); // overflow-hidden = scroll-lås + döljer chatten
      requestAnimationFrame(function () {
        // Fånga fokus i modalen (Dawns globala trapFocus, fokuserar även inputen)
        if (typeof trapFocus === 'function') { try { trapFocus(search, input); return; } catch (e) {} }
        if (input) { try { input.focus(); } catch (e) {} }
      });
    }
    function finishClose() {
      header.classList.remove('sv-search-active', 'sv-search-closing');
      document.body.classList.remove('sv-search-open', 'sv-search-closing', 'overflow-hidden');
      if (typeof removeTrapFocus === 'function') { try { removeTrapFocus(toggle); } catch (e) {} } // återställ fokus till sök-ikonen
    }
    function close() {
      if (!isOpen() || isClosing()) return;
      toggle.setAttribute('aria-expanded', 'false');
      // Mobil: håll fältet kvar (position:fixed) och spela ut-animationen (tonar/glider ut precis som
      // menyn) INNAN det tas bort → fältet går aldrig tillbaka in i gridet = ingen header-shake.
      // Dator: inline-fältet kollapsar direkt som tidigare.
      if (mqMobile.matches) {
        header.classList.add('sv-search-closing');
        document.body.classList.add('sv-search-closing');
        clearTimeout(closeTimer);
        closeTimer = setTimeout(finishClose, 520); // matchar ut-animationen (.52s)
      } else {
        finishClose();
      }
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      // "Stänger" räknas som stängt → klick under ut-animationen öppnar igen (avbryter stängningen).
      (isOpen() && !isClosing()) ? close() : open();
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && isOpen()) close();
    });

    // Klick utanför fältet + triggern stänger
    document.addEventListener('click', function (e) {
      if (isOpen() && !search.contains(e.target) && !toggle.contains(e.target)) close();
    });

    // Stäng-X (mobil-helskärm m.m.)
    search.querySelectorAll('[data-sv-search-close]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
  }

  function init() {
    document.querySelectorAll('.header').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
